import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class retencionService {


    /******* QUERIES ******/

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}ventas/retencion/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}ventas/retencion/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}ventas/retencion/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}ventas/retencion/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket(filter) {
        const response = await axios
            .get(`${ERP}ventas/retencion/pdf-ticket?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}ventas/retencion/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }

    async importarRegistrados(filter) {
        const response = await axios
            .get(`${ERP}ventas/retencion/importar-registrados?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async datosIniciales(filter) {
        const response = await axios
            .get(`${ERP}ventas/retencion/datos-iniciales?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ver(filter) {
        const response = await axios
            .get(`${ERP}ventas/retencion/ver?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

        async xml(filter) {
        const response = await axios
            .get(`${ERP}ventas/retencion/xml?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async cdr(filter) {
        const response = await axios
            .get(`${ERP}ventas/retencion/cdr?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}ventas/retencion`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}ventas/retencion`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async anular(data) {
        const response = await axios
            .put(`${ERP}ventas/retencion/anular`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async emitir(data) {
        const response = await axios
            .put(`${ERP}ventas/retencion/emitir`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async enviarCorreo(data) {
        const response = await axios
            .put(`${ERP}ventas/retencion/enviar-correo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

}

export default new retencionService();